import RegisterIndex from '@/views/register/index'
import RegisterPreRegistration from '@/views/register/PreRegistration'
import RegisterPreRegistrationSuccess from '@/views/register/PreRegistrationSuccess'
import RegisterRegistration from '@/views/register/Registration'
import RegisterRegistrationSuccess from '@/views/register/RegistrationSuccess'
// import RegisterPaymentNew from '@/views/register/PaymentNew'
import RegisterDoctorOfficeAgendaNew1 from '@/views/register/DoctorOfficeAgendaNew1'
import RegisterDoctorOfficeAgendaNew2 from '@/views/register/DoctorOfficeAgendaNew2'
import RegisterDoctorOfficeAgendaAppointmentInterval from '@/views/register/DoctorOfficeAgendaAppointmentInterval'
import RegisterDoctorOfficeAgendaStatus from '@/views/register/DoctorOfficeAgendaStatus'
import RegisterFinish from '@/views/register/Finish'
import RegisterEmailConfirmation from '@/views/register/EmailConfirm'

export default {
  path: '/register',
  name: 'Register',
  component: RegisterIndex,
  redirect: { name: 'RegisterSimpleRegistration' },
  children: [
    {
      path: 'pre-registration',
      name: 'RegisterPreRegistration',
      component: RegisterPreRegistration,
      meta: {
        step: 1
      }
    },
    {
      path: 'pre-registration/success',
      name: 'RegisterPreRegistrationSuccess',
      component: RegisterPreRegistrationSuccess,
      meta: {
        step: 2
      }
    },
    {
      path: 'registration',
      name: 'RegisterRegistration',
      component: RegisterRegistration,
      meta: {
        step: 1
      }
    },
    {
      path: 'registration/success',
      name: 'RegisterRegistrationSuccess',
      component: RegisterRegistrationSuccess,
      meta: {
        step: 2
      }
    },
    // {
    //   path: ':id/payment/new',
    //   name: 'RegisterPaymentNew',
    //   component: RegisterPaymentNew,
    //   meta: {
    //     step: 3
    //   }
    // },
    {
      path: ':id/doctor-office/agenda/appointment_interval',
      name: 'RegisterDoctorOfficeAgendaAppointmentInterval',
      component: RegisterDoctorOfficeAgendaAppointmentInterval,
      meta: {
        step: 3
      }
    },
    {
      path: ':id/doctor-office/agenda/new/1',
      name: 'RegisterDoctorOfficeAgendaNew1',
      component: RegisterDoctorOfficeAgendaNew1,
      meta: {
        step: 4
      }
    },
    {
      path: ':id/doctor-office/agenda/new/2',
      name: 'RegisterDoctorOfficeAgendaNew2',
      component: RegisterDoctorOfficeAgendaNew2,
      meta: {
        step: 5
      }
    },
    {
      path: ':id/doctor-office/agenda/status',
      name: 'RegisterDoctorOfficeAgendaStatus',
      component: RegisterDoctorOfficeAgendaStatus,
      meta: {
        step: 6
      }
    },
    {
      path: ':id/finish',
      name: 'RegisterFinish',
      component: RegisterFinish,
      meta: {
        step: 7
      }
    },
    {
      path: 'confirmation/:token',
      name: 'EmailConfirmation',
      component: RegisterEmailConfirmation
    }
  ]
}
